/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Base,
    BaseFromJSON,
    BaseFromJSONTyped,
    BaseToJSON,
    ChallengeFaqDetails,
    ChallengeFaqDetailsFromJSON,
    ChallengeFaqDetailsFromJSONTyped,
    ChallengeFaqDetailsToJSON,
    ChallengeOnboarding,
    ChallengeOnboardingFromJSON,
    ChallengeOnboardingFromJSONTyped,
    ChallengeOnboardingToJSON,
    ChallengeResponseAllOf,
    ChallengeResponseAllOfFromJSON,
    ChallengeResponseAllOfFromJSONTyped,
    ChallengeResponseAllOfToJSON,
    RewardConfigResponse,
    RewardConfigResponseFromJSON,
    RewardConfigResponseFromJSONTyped,
    RewardConfigResponseToJSON,
    TimeStamps,
    TimeStampsFromJSON,
    TimeStampsFromJSONTyped,
    TimeStampsToJSON,
} from './';

/**
 * Collection contains challenges that can be completed by users
 * @export
 * @interface ChallengeResponse
 */
export interface ChallengeResponse {
    /**
     * 
     * @type {string}
     * @memberof ChallengeResponse
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof ChallengeResponse
     */
    createdAt: number;
    /**
     * 
     * @type {number}
     * @memberof ChallengeResponse
     */
    updatedAt: number;
    /**
     * The title of the challenge
     * @type {string}
     * @memberof ChallengeResponse
     */
    name: string;
    /**
     * The title of the challenge on the card on DevourPlay Play tab.
     * @type {string}
     * @memberof ChallengeResponse
     */
    cardTitle?: string;
    /**
     * The description of the challenge
     * @type {string}
     * @memberof ChallengeResponse
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof ChallengeResponse
     */
    backgroundImageLarge?: string;
    /**
     * 
     * @type {string}
     * @memberof ChallengeResponse
     */
    backgroundImageSmall?: string;
    /**
     * 
     * @type {string}
     * @memberof ChallengeResponse
     */
    brandLogo?: string;
    /**
     * Hex color code for the brand
     * @type {string}
     * @memberof ChallengeResponse
     */
    brandColor?: string;
    /**
     * 
     * @type {Array<RewardConfigResponse>}
     * @memberof ChallengeResponse
     */
    rewardConfigs?: Array<RewardConfigResponse>;
    /**
     * UNIX timestamp for when the challenge starts
     * @type {number}
     * @memberof ChallengeResponse
     */
    start: number;
    /**
     * UNIX timestamp for when the challenge ends
     * @type {number}
     * @memberof ChallengeResponse
     */
    end: number;
    /**
     * 
     * @type {boolean}
     * @memberof ChallengeResponse
     */
    hasEnded?: boolean;
    /**
     * Whether the challenge is active
     * @type {boolean}
     * @memberof ChallengeResponse
     */
    isActive?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ChallengeResponse
     */
    instantRewardQuest?: string;
    /**
     * 
     * @type {number}
     * @memberof ChallengeResponse
     */
    numberOfEntrants?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ChallengeResponse
     */
    showChallengeCompleteNotification?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ChallengeResponse
     */
    showInstantRewardQuestCompleteNotification?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ChallengeResponse
     */
    challengeCompleteNotificationMessage?: string;
    /**
     * 
     * @type {string}
     * @memberof ChallengeResponse
     */
    instantRewardQuestCompleteNotificationMessage?: string;
    /**
     * 
     * @type {string}
     * @memberof ChallengeResponse
     */
    termsUrl?: string;
    /**
     * 
     * @type {ChallengeOnboarding}
     * @memberof ChallengeResponse
     */
    onboardingSection?: ChallengeOnboarding;
    /**
     * 
     * @type {Array<ChallengeFaqDetails>}
     * @memberof ChallengeResponse
     */
    faqs?: Array<ChallengeFaqDetails>;
    /**
     * 
     * @type {string}
     * @memberof ChallengeResponse
     */
    prizePoolFeatureImage?: string;
    /**
     * 
     * @type {number}
     * @memberof ChallengeResponse
     */
    titleFontSize?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof ChallengeResponse
     */
    questConfigIds?: Array<string>;
    /**
     * The slug of the brand map associated with this challenge.
     * @type {string}
     * @memberof ChallengeResponse
     */
    brandMapSlug?: string;
}

export function ChallengeResponseFromJSON(json: any): ChallengeResponse {
    return ChallengeResponseFromJSONTyped(json, false);
}

export function ChallengeResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChallengeResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'createdAt': json['createdAt'],
        'updatedAt': json['updatedAt'],
        'name': json['name'],
        'cardTitle': !exists(json, 'cardTitle') ? undefined : json['cardTitle'],
        'description': json['description'],
        'backgroundImageLarge': !exists(json, 'backgroundImageLarge') ? undefined : json['backgroundImageLarge'],
        'backgroundImageSmall': !exists(json, 'backgroundImageSmall') ? undefined : json['backgroundImageSmall'],
        'brandLogo': !exists(json, 'brandLogo') ? undefined : json['brandLogo'],
        'brandColor': !exists(json, 'brandColor') ? undefined : json['brandColor'],
        'rewardConfigs': !exists(json, 'rewardConfigs') ? undefined : ((json['rewardConfigs'] as Array<any>).map(RewardConfigResponseFromJSON)),
        'start': json['start'],
        'end': json['end'],
        'hasEnded': !exists(json, 'hasEnded') ? undefined : json['hasEnded'],
        'isActive': !exists(json, 'isActive') ? undefined : json['isActive'],
        'instantRewardQuest': !exists(json, 'instantRewardQuest') ? undefined : json['instantRewardQuest'],
        'numberOfEntrants': !exists(json, 'numberOfEntrants') ? undefined : json['numberOfEntrants'],
        'showChallengeCompleteNotification': !exists(json, 'showChallengeCompleteNotification') ? undefined : json['showChallengeCompleteNotification'],
        'showInstantRewardQuestCompleteNotification': !exists(json, 'showInstantRewardQuestCompleteNotification') ? undefined : json['showInstantRewardQuestCompleteNotification'],
        'challengeCompleteNotificationMessage': !exists(json, 'challengeCompleteNotificationMessage') ? undefined : json['challengeCompleteNotificationMessage'],
        'instantRewardQuestCompleteNotificationMessage': !exists(json, 'instantRewardQuestCompleteNotificationMessage') ? undefined : json['instantRewardQuestCompleteNotificationMessage'],
        'termsUrl': !exists(json, 'termsUrl') ? undefined : json['termsUrl'],
        'onboardingSection': !exists(json, 'onboardingSection') ? undefined : ChallengeOnboardingFromJSON(json['onboardingSection']),
        'faqs': !exists(json, 'faqs') ? undefined : ((json['faqs'] as Array<any>).map(ChallengeFaqDetailsFromJSON)),
        'prizePoolFeatureImage': !exists(json, 'prizePoolFeatureImage') ? undefined : json['prizePoolFeatureImage'],
        'titleFontSize': !exists(json, 'titleFontSize') ? undefined : json['titleFontSize'],
        'questConfigIds': !exists(json, 'questConfigIds') ? undefined : json['questConfigIds'],
        'brandMapSlug': !exists(json, 'brandMapSlug') ? undefined : json['brandMapSlug'],
    };
}

export function ChallengeResponseToJSON(value?: ChallengeResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'createdAt': value.createdAt,
        'updatedAt': value.updatedAt,
        'name': value.name,
        'cardTitle': value.cardTitle,
        'description': value.description,
        'backgroundImageLarge': value.backgroundImageLarge,
        'backgroundImageSmall': value.backgroundImageSmall,
        'brandLogo': value.brandLogo,
        'brandColor': value.brandColor,
        'rewardConfigs': value.rewardConfigs === undefined ? undefined : ((value.rewardConfigs as Array<any>).map(RewardConfigResponseToJSON)),
        'start': value.start,
        'end': value.end,
        'hasEnded': value.hasEnded,
        'isActive': value.isActive,
        'instantRewardQuest': value.instantRewardQuest,
        'numberOfEntrants': value.numberOfEntrants,
        'showChallengeCompleteNotification': value.showChallengeCompleteNotification,
        'showInstantRewardQuestCompleteNotification': value.showInstantRewardQuestCompleteNotification,
        'challengeCompleteNotificationMessage': value.challengeCompleteNotificationMessage,
        'instantRewardQuestCompleteNotificationMessage': value.instantRewardQuestCompleteNotificationMessage,
        'termsUrl': value.termsUrl,
        'onboardingSection': ChallengeOnboardingToJSON(value.onboardingSection),
        'faqs': value.faqs === undefined ? undefined : ((value.faqs as Array<any>).map(ChallengeFaqDetailsToJSON)),
        'prizePoolFeatureImage': value.prizePoolFeatureImage,
        'titleFontSize': value.titleFontSize,
        'questConfigIds': value.questConfigIds,
        'brandMapSlug': value.brandMapSlug,
    };
}


